import VIPHostInfoHotline from './VIPHostInfoHotline';

export default VIPHostInfoHotline;
